/**
 * PLAN-OFFER-01 slice E (2026-10-29): the one-tap on a plan-offer follow-up.
 * The sweep writes two kinds — "offer:<sale>" (expired · Resend keeps the price)
 * and "offer-unpaid:<sale>" (accepted · unpaid 30 days · the office chases the
 * invoice or declines the plan). Resend re-opens the offer for another 60 days
 * at the price it was sent with, closes the follow-up, and opens the proposal
 * page so the staff bar can send the link. The unpaid one points at the
 * customer's Proposals card, where Record Payment lives.
 */
import { Loader2, Send } from "lucide-react";
import { useResendPlanOffer, offerProposalUrl } from "@/features/agreements/planOffers";

export function offerRef(sourceRef: string | null | undefined): { kind: "expired" | "unpaid"; saleId: string } | null {
  const m = /^offer(-unpaid)?:([0-9a-f-]{36})$/i.exec(sourceRef ?? "");
  if (!m) return null;
  return { kind: m[1] ? "unpaid" : "expired", saleId: m[2] };
}

export function OfferFollowupAction({ sourceRef, compact }: { sourceRef: string | null | undefined; compact?: boolean }) {
  const ref = offerRef(sourceRef);
  const resend = useResendPlanOffer();
  if (!ref || ref.kind !== "expired") return null;
  const go = async () => {
    try {
      const r = await resend.mutateAsync(ref.saleId);
      const url = r.token ? offerProposalUrl({ quote_token: r.token }) : null;
      if (url) window.open(url, "_blank");
    } catch { /* the card's error line shows */ }
  };
  return (
    <button
      type="button"
      disabled={resend.isPending}
      onClick={() => void go()}
      title="Resend the plan offer — same price, a new 60 days; opens the proposal page to send it"
      className={compact
        ? "inline-flex shrink-0 items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-700 hover:bg-emerald-100 disabled:opacity-50"
        : "inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[11px] font-semibold text-emerald-700 hover:bg-emerald-100 disabled:opacity-50"}
    >
      {resend.isPending ? <Loader2 className="h-3 w-3 animate-spin" /> : <Send className="h-3 w-3" />} Resend
    </button>
  );
}
